import React from "react";
import UpdatePasswordForm from "./UpdatePasswordForm";

function UpdatePasswordPage() {
  return <UpdatePasswordForm />;
}

export default UpdatePasswordPage;
